import { useTextField } from '@react-aria/textfield';
import classNames from 'classnames';
import React from 'react';

interface Props {
  label: string;
  placeholder?: string;
  value: string;
  isDisabled?: boolean;
  error?: string;
  onChange: (newValue: string) => void;
  onSubmit?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
}

export const TextField: React.FC<Props> = (props) => {
  let { label, error, onSubmit } = props;
  let ref = React.useRef<HTMLInputElement>(null);
  const handleKeyDown = React.useCallback(
    (e) => {
      if (e?.key === 'Enter') {
        if (ref && ref.current) {
          ref.current.blur();
        }

        if (onSubmit) {
          onSubmit();
        }
      }
    },
    [onSubmit]
  );
  let { labelProps, inputProps } = useTextField(
    {
      ...props,
      onKeyDown: handleKeyDown,
    },
    ref
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <label {...labelProps} className="font-medium text-gray-700">
        {label}
      </label>
      {/* @ts-ignore */}
      <input
        {...inputProps}
        ref={ref}
        className={classNames('border w-full p-2 rounded', {
          'border-red-400': !!error,
          'border-gray-300': !error,
        })}
      />
      {error && <span className="my-1 text-red-600 text-sm font-medium">{error}</span>}
    </div>
  );
};
